module.exports = __webpack_public_path__ + "static/media/us_immigration_ban.df3bb373.jpg";